import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import {
  articleListColumns,
  smsListColumns,
} from "../../constant/tablesColumns/tablesColums";

export default function SmsList() {
  const [articleData, setSmsData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getSms = async (params) => {
    const path = "admin/sms/config";
    try {
      const response = await getApi({ path, params: { ...params } });
      setSmsData(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSms({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getSms(allFilter);
  };

  const data = articleData?.map((item) => {
    return {
      ...item,
      showIsDefault: item?.isDefault ? "بله" : "خیر",
    };
  });

  const navigate = useNavigate();

  const editUser = (singleUser) => {
    navigate("/edit-sms", { state: singleUser });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست کانفیگ پیامک"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table columns={smsListColumns} rows={data} onEdit={editUser} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
